// tslint:disable:triple-equals
import { notification } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import * as React from 'react';
import { MutationFunc } from 'react-apollo';

import { attachmentUrl } from '../../../../../config/config';
import ValueFilesRow from '../ValueFilesRow';

interface IProductFilesProps {
  productFiles: Array<GQL.IImage>;
  productId: number;
  onChange: (files: Array<GQL.IImage>) => void;
  removeFile: Function;

  changePriorities?: MutationFunc;
  refetch: Function;
}

interface IProductFilesState {
  valueFiles: Array<any>;
}

export default class ProductFiles extends React.Component<IProductFilesProps, IProductFilesState> {

  constructor(props: IProductFilesProps) {
    super(props);

    this.state = {
      valueFiles: [...props.productFiles],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  public render() {
    return (
      <ValueFilesRow
        handleOrderChange={data => this.handleOrderChange(data)}
        handleChange={this.handleChange}
        handleRemove={this.handleRemove}
        productId={this.props.productId}
        url={attachmentUrl || ''}
        valueFiles={this.state.valueFiles}
      />
    );
  }

  private handleRemove(p: UploadFile) {
    if (p.response) {
      return this.props.removeFile({ variables: { id: p.response.id } });
    }

    return this.props.removeFile({ variables: { id: p.uid } });
  }

  private async handleOrderChange(data: any) {
    this.handleChange(data);

    if (this.props.changePriorities) {
      // přetřídění před odesláním do backendu
      const resort = data.fileList
        .sort((a, b) => a.priority < b.priority ? -1 : 0)
        .map((f: any, i: number) => {
          f.priority = i + 1;
          return f;
        });

      // odeslání do backendu
      const result = await this.props.changePriorities({
        variables: {
          filesToChange: resort.map(f => {
            return {
              id: f.id,
              newPriority: f.priority
            };
          })
        }
      });

      if (result.data.changePriorities) {
        notification['success']({
          message: 'Info',
          description: `Order of files saved.`
        });
      }
    }
  }

  private handleChange({ fileList }: any) {
    if (fileList == undefined) {
      return;
    }

    const newFileList = fileList.map((i: any) => {
      if (i.originFileObj && !i.id && i.response) {
        return i.response;
      } else {
        return i;
      }
    });

    this.setState({
      valueFiles: newFileList
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductFilesTab/ProductFiles/ProductFiles.tsx